import { graphql } from '../../services/graphql'
import OrderStatus from '../../models/OrderStatus'

const state = {
  search: '',
  limit: 50,
  offset: 0,
  isOngoingFilter: false,
  onlyMissingProductFilter: false,
  orders: [],
  loading: true,
  status_id: 0,
  orderStatuses: [],
  selectedOrder: null,
  selectedStatus: new OrderStatus()
}
const getters = {
  countSelected(state) {
    return state.orders.filter(order => order.selected).length
  },
  selectedOrders(state) {
    return state.orders.filter(order => order.selected)
  }
}

const mutations = {
  updateOrders(state, payload) {
    console.log('order payload!', payload)
    state.orders = payload
  },

  updateSearch(state, value) {
    state.search = value
  },

  updateOrderStatuses(state, statuses) {
    state.orderStatuses = statuses
  },

  updateSelected(state, { value, order }) {
    _.find(state.orders, {
      id: order.id
    }).selected = value
  },
  resetSelected(state) {
    state.orders.forEach(order => (order.selected = false))
  },

  setSelectedOrder(state, order) {
    state.selectedOrder = order
  },

  setSelectedStatus(state, status) {
    state.selectedStatus = new OrderStatus(status)
  },

  setLoading(state, value) {
    state.loading = value
  },

  updateOrder(state, order) {
    let item = state.orders.find(item => item.id == order.id)
    Object.assign(item, order)
  },

  setIsOngoingFilter(state, value) {
    state.isOngoingFilter = value
  },

  setOrderStatusFilter(state, value) {
    state.status_id = value
  },

  setOnlyMissingProductFilter(state, value) {
    state.onlyMissingProductFilter = value
  }
}

const actions = {
  getOrders(context) {
    context.commit('setLoading', true)
    const GET_ORDERS_QUERY = `
      query getOrders($limit: Int, $offset: Int, $search: String, $status_id: Int, $is_ongoing: Boolean, $only_missing: Boolean ) { 
        orders(limit:$limit, offset:$offset, search: $search, status_id: $status_id, is_ongoing: $is_ongoing, only_missing: $only_missing) {
          id
          name
          orderStatusId
          status {
            id
            color
            name
          }
          total
          date
          comments {
            id
            user_id
            comment
            created_at
          }
          isOngoing
          missingProducts {
            id
            name
            model
            price
            quantity
            image
          }
          statusHistory {
            comment
            status {
              id
              color
              name
            }
          }
          products {
            id
            name
            price
            image
            quantity
            warehouseStock {
              name
              model
              quantity
            }

          }
          totals {
            id
            code
            title
            text
            value
          }
          customer {
            id
            email
            name
            telephone
            gravatarUrl
          }
        }
      }`

    graphql()
      .request(GET_ORDERS_QUERY, {
        limit: context.state.limit,
        offset: context.state.offset,
        search: context.state.search,
        status_id: context.state.status_id,
        is_ongoing: context.state.isOngoingFilter,
        only_missing: context.state.onlyMissingProductFilter
      })
      .then(data => {
        console.log('=============>', data)
        context.commit('setLoading', false)
        context.commit(
          'updateOrders',
          data.orders.map(order =>
            Object.assign(order, {
              showActions: false,
              showComments: false,
              showMissingProducts: false,
              showHistory: false,
              selected: false
            })
          )
        )
      })
  },
  getOrderStatuses(context) {
    let query = `query getOrderStatuses {
      orderStatus {
        id
        name
        color
      }
    }`
    graphql()
      .request(query)
      .then(data => {
        const notSelectedStatus = {
          name: '-- Todos --',
          id: null,
          color: '#fff'
        }
        const lostItemsStatus = {
          name: 'Pedidos Perdido',
          id: 0,
          color: '#cecece'
        }

        data.orderStatus.unshift(lostItemsStatus)
        data.orderStatus.unshift(notSelectedStatus)

        context.commit('updateOrderStatuses', data.orderStatus)
      })
  },

  async updateOrder(context, data) {
    const { id, isOngoing, orderStatusId, ...rest } = data
    let mutation = `
      mutation updateOrder($order: OrderInput) {
        updateOrder(order: $order) 
      }
    `
    await graphql().request(mutation, {
      order: {
        id,
        isOngoing,
        orderStatusId
      }
    })
    context.commit('updateOrder', data)
  },

  createOrderHistory(context, { id, status_id, comment, notify }) {
    let mutation = `mutation {
      createOrderHistory(id: ${id}, status_id: ${status_id}, notify: ${notify}, comment: "${comment}")
    }`
    graphql()
      .request(mutation)
      .then(data => 'ok')
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/components/orders/orders.store.js